<template>
  <div>
    <template-publish-modal
      :selected-template="selectedTemplate"
      :services-by-zone="servicesByZone"
    />
    <b-button
      class="mb-2"
      variant="primary"
      @click="handleAddTemplate"
    >
      <span class="text-nowrap">Add Template</span>
    </b-button>

    <b-card class="mb-0">
      <b-form
        autocomplete="off"
        @submit.prevent="fetchTemplates"
      >
        <b-row class="mb-12">
          <b-col md="10">
            <b-form-input
              v-model="queryParams.name"
              name="name"
              type="text"
              placeholder="Search by Name"
              clearable
            />
          </b-col>
          <b-col md="2">
            <b-button
              variant="primary"
              type="submit"
            >
              Search
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
    <b-table
      hoverr
      striped
      :items="getTemplateList"
      responsive
      :fields="tableColumns"
      show-empty
      empty-text="No matching data found"
      selectable
      @row-selected="navigate"
    >
      <template #cell(name)="data">
        {{ data.item.name }}
      </template>
      <template #cell(updatedAt)="data">
        {{ data.item.created_at | formatDate }}
      </template>
      <template #cell(effectiveDateTime)="data">
        {{ data.item.effective_date_time | formatDate }}
      </template>

      <template #cell(actions)="data">
        <b-dropdown
          variant="link"
        >
          <template #button-content>
            <feather-icon
              icon="MoreVerticalIcon"
              size="16"
              class="align-middle text-body"
            />
          </template>
          <b-dropdown-item
            v-if="$can('write', 'templates')"
            @click="cloneTemplate(data.item)"
          >
            <feather-icon icon="CopyIcon" />
            <span class="align-middle ml-50">Clone</span>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="$can('write', 'versions')"
            @click="publishTemplate(data.item)"
          >
            <feather-icon icon="UploadIcon" />
            <span class="align-middle ml-50">Publish</span>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="$can('write', 'templates')"
            @click="deleteTemplate(data.item)"
          >
            <feather-icon icon="TrashIcon" />
            <span class="align-middle ml-50">Delete</span>
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
  </div>
</template>

<script>
import {
  BTable, BDropdown, BDropdownItem, BButton, BRow, BCol, BForm, BFormInput, BCard,
} from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import templateStore from '../store'
import zonesStore from '@/views/zones/zoneStoreModule'
import useTemplateList from '../hooks/useTemplateList'
import { successNotification } from '@/utils/toast-notifications'
import TemplatePublishModal from './TemplatePublishModal.vue'

export default {
  components: {
    BTable,
    BDropdown,
    BDropdownItem,
    BButton,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BCard,
    TemplatePublishModal,
  },
  setup(props, ctx) {
    useRegisterStoreModule('templates', templateStore)
    useRegisterStoreModule('zones', zonesStore)
    const {
      templatesLoading, getTemplateList, servicesByZone, ...rest
    } = useTemplateList(ctx)

    const selectedTemplate = ref({})
    watch(templatesLoading, () => {
      ctx.emit('templates-loading-state', templatesLoading.value)
    }, { immediate: true })
    const handleAddTemplate = () => {
      ctx.root.$router.push('/templates/new')
    }
    const navigate = evt => {
      if (evt[0].id) {
        ctx.root.$router.push(`/pricing-templates/edit/${evt[0].id}`)
      }
    }
    return {
      navigate,
      ...rest,
      getTemplateList,
      handleAddTemplate,
      selectedTemplate,
      servicesByZone,
    }
  },
  methods: {
    async cloneTemplate(item) {
      await this.$swal({
        title: `Clone <b class="text-warning">${item.name}</b> ?`,
        text: '',
        width: '40em',
        showCancelButton: true,
        confirmButtonText: 'Yes, Clone',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        showLoaderOnConfirm: true,
        preConfirm: res => {
          if (!res) return null
          return this.$store.dispatch('templates/cloneTemplate', item.id).catch(err => {
            this.$swal.showValidationMessage(`Error:  ${err.response.data.error.detail.message}`)
          })
        },
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('templates/fetchTemplates', {})
          successNotification('Cloned successfully!')
        }
      })
    },

    async publishTemplate(item) {
      this.selectedTemplate = item
      this.$bvModal.show('publish-template-modal')
    },

    async deleteTemplate(item) {
      await this.$swal({
        title: `Delete <b class="text-warning">${item.name}</b> ?`,
        text: "You won't be able to revert this!",
        icon: 'warning',
        width: '40em',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        showLoaderOnConfirm: true,
        preConfirm: res => {
          if (!res) return null
          return this.$store.dispatch('templates/deleteTemplate', item.id).catch(err => {
            this.$swal.showValidationMessage(`Error:  ${err.response.data.error.detail.message}`)
          })
        },
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('templates/fetchTemplates', {})
          successNotification('Deleted successfully!')
        }
      })
    },
  },
}
</script>

<style>

</style>
